<div class="outageScreen">
  <div class="cover">
    {{ chatOutageMsg }}
  </div>
</div>
